import React, { useEffect, useState } from 'react';
import { getStudentByHashedStudentId } from '../services/studentService';
import { AccountIcon } from '@qualtrics/ui-react/icons';
import styles from './studentInfo.module.css';

const StudentInfo = ({hashedStudentId, brandId}) => {
    const [studentName, setStudentName] = useState(undefined);

    useEffect(() => {

        const getStudent = async () => {
            const student = await getStudentByHashedStudentId(hashedStudentId, brandId);
            const name = student["firstName"] + " " + student["lastName"];
            setStudentName(name);
        }

        getStudent();
    }, []);

    if (studentName === undefined || studentName === "") {
        return <></>;
    }

    return (
        <div className={styles['student-name-row']}>  
            <AccountIcon />
            <div className={styles['student-name']}>
                {studentName}
            </div>
        </div>
    );
}

export default StudentInfo;